import {
  GET_ALL_SAVED_TARGETS_REQUEST,
  GET_ALL_SAVED_TARGETS_SUCCESS,
  GET_ALL_SAVED_TARGETS_FAILURE,
  statusType
} from '../../actions'

const initial = {
  data: [],
  status: statusType.IDLE
}

const targets = (state = initial, action) => {
  switch (action.type) {
    case GET_ALL_SAVED_TARGETS_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_ALL_SAVED_TARGETS_SUCCESS:
      return {
        data: action.payload,
        status: statusType.SUCCESS
      }

    case GET_ALL_SAVED_TARGETS_FAILURE:
      return {
        error: action.error,
        status: statusType.ERROR
      }

    default:
      return state
  }
}

export default targets
